import { Notification } from "element-ui";
import "whatwg-fetch";
import { ERequestType, fetchPostHelper } from "./fetch";
import { dateToTimeStamp } from "./timeTool";

export const sendResaAskReview = function (mailDatas) {
	const { clientEmail } = mailDatas;

	return new Promise((resolve, reject) => {
		if (clientEmail && clientEmail !== "") {
			fetchPostHelper(ERequestType.MAILER.S_RESA_ASK_REVIEW, mailDatas)
				.then(function (result) {
					resolve(result);
				})
				.catch((err) => {
					console.error("sendResaAskReview", err);
					reject(err);
				});
		}
	});
};

export const sendResaConfirmedMessage = function (massageDatas) {
	const { sendSms, clientTel, clientTelPreFix, ...mailDatas } = massageDatas;
	const { clientEmail, restoid } = massageDatas;

	if (clientEmail && clientEmail !== "") {
		fetchPostHelper(ERequestType.MAILER.S_RESA_CONFIRMED, mailDatas)
			.then(function (result) {
				Notification.success({
					title: "Informations renvoyées",
					message: "Les informations ont été renvoyées",
					position: "bottom-right",
				});
			})
			.catch((err) => {
				console.error("sendResaConfirmedMessage", err);
			});
	}

	if (sendSms && clientTel && clientTel !== "") {
		const now = new Date();
		let smsDatas = {
			ts: dateToTimeStamp(now.getDate(), now.getMonth(), now.getFullYear()),
			clientTel,
			clientTelPreFix,
			restoid,
			data: mailDatas,
		};
		fetchPostHelper(ERequestType.SMS.S_RESA_CONFIRMED, smsDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaConfirmedSms", err);
			});
	}
};

export const sendResaPreConfirmedMessage = function (massageDatas) {
	const { sendSms, clientTel, clientTelPreFix, ...mailDatas } = massageDatas;
	const { clientEmail, restoid } = massageDatas;

	if (clientEmail && clientEmail !== "") {
		fetchPostHelper(ERequestType.MAILER.S_RESA_PRE_CONFIRMED, mailDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaPreConfirmedMail", err);
			});
	}

	if (sendSms && clientTel && clientTel !== "") {
		const now = new Date();
		let smsDatas = {
			ts: dateToTimeStamp(now.getDate(), now.getMonth(), now.getFullYear()),
			clientTel,
			clientTelPreFix,
			restoid,
			data: mailDatas,
		};
		fetchPostHelper(ERequestType.SMS.S_RESA_PRE_CONFIRMED, smsDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaPreConfirmedSms", err);
			});
	}
};

export const sendResaToConfirmRestaurateur = function (mailDatas) {
	const { clientEmail } = mailDatas;

	// check clientMail
	let mailC = clientEmail;
	if (!clientEmail || clientEmail === "")
		mailC = "noreply@clienthavenomail.com";

	mailDatas.clientEmail = mailC;
	fetchPostHelper(ERequestType.MAILER.S_RESA_CONFIRMED_RESTO, mailDatas)
		.then(function (result) {})
		.catch((err) => {
			console.error("sendResaToConfirmRestaurateur", err);
		});
};

export const sendResaTakedRestaurateur = function (mailDatas) {
	const { clientEmail } = mailDatas;

	// check clientMail
	let mailC = clientEmail;
	if (!clientEmail || clientEmail === "")
		mailC = "noreply@clienthavenomail.com";

	mailDatas.clientEmail = mailC;

	fetchPostHelper(ERequestType.MAILER.S_RESA_TAKED_RESTO, mailDatas)
		.then(function (result) {})
		.catch((err) => {
			console.error("sendResaTakedRestaurateur", err);
		});
};

export const sendResaCancelledMessage = function (massageDatas) {
	const { sendSms, clientTel, clientTelPreFix, ...mailDatas } = massageDatas;
	const { clientEmail, restoid } = massageDatas;

	if (clientEmail && clientEmail !== "") {
		fetchPostHelper(ERequestType.MAILER.S_RESA_CANCELLED, mailDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaCancelledMail", err);
			});
	}

	if (sendSms && clientTel && clientTel !== "") {
		const now = new Date();
		let smsDatas = {
			ts: dateToTimeStamp(now.getDate(), now.getMonth(), now.getFullYear()),
			clientTel,
			clientTelPreFix,
			restoid,
			data: mailDatas,
		};
		fetchPostHelper(ERequestType.SMS.S_RESA_CANCELLED, smsDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaCancelledSms", err);
			});
	}
};

export const sendResaModifyMail = function (mailDatas) {
	const { clientEmail } = mailDatas;

	if (clientEmail && clientEmail !== "") {
		fetchPostHelper(ERequestType.MAILER.S_RESA_MODIFY, mailDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaModifyMail", err);
			});
	}
};

export const sendResaCancelRestaurateur = function (mailDatas) {
	const { clientEmail } = mailDatas;

	// check clientMail
	let mailC = clientEmail;
	if (!clientEmail || clientEmail === "")
		mailC = "noreply@clienthavenomail.com";

	mailDatas.clientEmail = mailC;
	fetchPostHelper(ERequestType.MAILER.S_RESA_CANCELLED_RESTO, mailDatas)
		.then(function (result) {})
		.catch((err) => {
			console.error("sendResaCancelRestaurateur", err);
		});
};

export const sendResaModifyRestaurateur = function (mailDatas) {
	const { clientEmail } = mailDatas;

	// check clientMail
	let mailC = clientEmail;
	if (!clientEmail || clientEmail === "")
		mailC = "noreply@clienthavenomail.com";

	mailDatas.clientEmail = mailC;
	fetchPostHelper(ERequestType.MAILER.S_RESA_MODIFY_RESTO, mailDatas)
		.then(function (result) {})
		.catch((err) => {
			console.error("sendResaModifyRestaurateur", err);
		});
};

export const sendResaEchecPaiementRestaurateur = function (mailDatas) {
	const { clientEmail } = mailDatas;

	// check clientMail
	let mailC = clientEmail;
	if (!clientEmail || clientEmail === "")
		mailC = "noreply@clienthavenomail.com";

	mailDatas.clientEmail = mailC;

	fetchPostHelper(ERequestType.MAILER.S_RESA_PAIEMENTFAIL_RESTO, mailDatas)
		.then(function (result) {})
		.catch((err) => {
			console.error("sendResaModifyRestaurateur", err);
		});
};

export const sendResaEchecPaiement = function (mailDatas) {
	const { clientEmail } = mailDatas;

	// if clientEmail exist
	if (clientEmail && clientEmail !== "") {
		fetchPostHelper(ERequestType.MAILER.S_RESA_PAIEMENTFAIL, mailDatas)
			.then(function (result) {})
			.catch((err) => {
				console.error("sendResaEchecPaiement", err);
			});
	}
};
